/**
 * 장기선결제 추가 모달 ($j.Ui.JBModal.target 결합).
 * 레거시 public/skw_3310.php 대체.
 *
 * 사용법:
 *   $j.Ui.JBModal.target('prepay-modal', {
 *       target: '$j.F.Admin.Member.PrepayForm',
 *       data:   { mbNo: 123 },
 *       title:  '장기선결제 추가',
 *   });
 */
import Util from '../../../Common/Util';
export default class PrepayForm {
    constructor() { this.$wrap = null; }
    destroy() {}

    init() {
        this.mbNo = this.data.mbNo;
        $(`#${this.id}`).html('<div style="padding:20px;text-align:center;color:var(--adm-text-muted)">불러오는 중…</div>');
        this.load();
    }

    load() {
        const self = this;
        $.ajax({
            type: 'get',
            url: '/adm/ajax/member/prepay/form',
            data: { mb_no: self.mbNo },
            dataType: 'json',
            success(data) {
                if (!data.result) {
                    $(`#${self.id}`).html(`<div style="padding:20px;text-align:center;color:var(--adm-kw-red, red)">${self._esc(data.message || '데이터를 불러오지 못했습니다.')}</div>`);
                    return;
                }
                self.state = data;
                self.render();
                self.bind();
            },
            error() {
                $(`#${self.id}`).html('<div style="padding:20px;text-align:center;color:var(--adm-kw-red, red)">데이터를 불러오지 못했습니다.</div>');
            },
        });
    }

    // 관리자 토큰만 쓴다 — 회비결제방식 · 장기선결제 내역 창과 같은 모양. 기간을 고르면 시작~종료 · 금액이 나오고 한 달씩 옮길 수 있다
    render() {
        const s = this.state;
        const periodLabel = p => p == 12 ? '1년' : p == 24 ? '2년' : p == 36 ? '3년' : `${p}개월`;
        const periodBtns = Object.entries(s.periods).map(([p, endYm]) =>
            `<button type="button" class="me-btn ymbtn" data-period="${p}" data-start="${s.startYm}" data-end="${endYm}"${s.isCms ? ' disabled' : ''}>${periodLabel(p)}</button>`
        ).join('');

        $(`#${this.id}`).html(`<style>
.pf{font-size:13px}
.pf-row{display:flex;align-items:center;gap:8px;padding:8px 0;border-bottom:1px solid var(--adm-border)}
.pf-row:last-of-type{border-bottom:0}
.pf-k{flex:0 0 56px;color:var(--adm-text-muted)}
.pf-v{flex:1;display:flex;align-items:center;flex-wrap:wrap;gap:6px}
.pf .ymbtn.is-on{background:var(--adm-primary, #3b82f6);border-color:var(--adm-primary, #3b82f6);color:#fff}
.pf-ym{width:80px;text-align:center}
.pf-price{font-weight:700}
.pf-warn{margin-top:6px;font-size:12px;color:var(--adm-kw-red, red)}
.pf-note{margin-top:6px;font-size:11.5px;color:var(--adm-text-muted)}
.pf-ft{display:flex;justify-content:flex-end;gap:6px;margin-top:12px}
</style>
        <div class="pf">
            <form id="prepayform" method="post" onsubmit="return false">
                <input type="hidden" name="mb_no" value="${s.mbNo}">
                <input type="hidden" name="period">
                <input type="hidden" name="jobtype" value="prepay_add">
                <div class="pf-row"><span class="pf-k">CMS</span><span class="pf-v">${this._esc(s.cmsnum)}</span></div>
                <div class="pf-row"><span class="pf-k">기간</span><span class="pf-v">${periodBtns}</span></div>
                <div class="pf-row pf-when" hidden><span class="pf-k">적용</span><span class="pf-v">
                    <button type="button" id="month_prev" class="me-btn" aria-label="한 달 앞으로"><i class="fas fa-chevron-left"></i></button>
                    <input type="text" class="me-input pf-ym" name="start_ym" id="start_ym" readonly> ~
                    <input type="text" class="me-input pf-ym" name="end_ym" id="end_ym" readonly>
                    <button type="button" id="month_next" class="me-btn" aria-label="한 달 뒤로"><i class="fas fa-chevron-right"></i></button></span></div>
                <div class="pf-row pf-when" hidden><span class="pf-k">금액</span><span class="pf-v"><span class="pf-price" id="prepay_price"></span></span></div>
            </form>
            ${s.isCms ? '<div class="pf-warn">CMS 회원입니다. CMS 를 먼저 해제한 뒤 장기선결제를 추가해 주세요 — 그대로 넣으면 자동이체도 빠져 회비를 두 번 받습니다.</div>' : ''}
            <div class="pf-warn pf-now" hidden></div>
            <div class="pf-note">기본 시작은 다음 달 1일입니다. 화살표로 한 달씩 옮깁니다. 같은 기간에 이미 선결제가 있으면 추가되지 않습니다.</div>
            <div class="pf-ft">
                <button type="button" id="prepay-log" class="me-btn"><i class="fas fa-history"></i> 내역</button>
                <button type="button" id="prepay-save" class="me-btn me-btn--accent" disabled>추가</button>
            </div>
        </div>`);
    }

    bind() {
        const self = this;
        const $w = $(`#${this.id}`);

        $w.find('.ymbtn').off('click').on('click', function () {
            const period = parseInt($(this).data('period'), 10);
            const startYm = $(this).data('start');
            const endYm = $(this).data('end');
            self.setYm(period, startYm, endYm, this);
        });

        $w.find('#month_prev').off('click').on('click', () => self.goMonth(-1));
        $w.find('#month_next').off('click').on('click', () => self.goMonth(1));
        $w.find('#prepay-save').off('click').on('click', () => self.save());
        $w.find('#prepay-log').off('click').on('click', () => self.openLog());
    }

    setYm(period, startYm, endYm, el) {
        const $w = $(`#${this.id}`);
        const f = $w.find('#prepayform')[0];
        f.period.value = period;
        f.start_ym.value = startYm;
        f.end_ym.value = endYm;
        $w.find('.ymbtn').removeClass('is-on');
        $(el).addClass('is-on');
        $w.find('#prepay_price').text(`${Util.formatNumber(this.state.prepayPrice[period])}원`);
        $w.find('.pf-when').prop('hidden', false);
        $w.find('#prepay-save').prop('disabled', false);
        this.checkNow();
    }

    /** 시작을 이번 달로 당겼으면 — 이번 달부터 바로 선결제 회원이 되고, 이미 받은 이번 달 회비가 있으면 두 번 받게 된다 */
    checkNow() {
        const s = this.state, $w = $(`#${this.id}`), now = $w.find('#start_ym').val() === s.thisYm;
        $w.find('.pf-now').prop('hidden', !now).text(!now ? '' : (s.paidThisMonth > 0
            ? `이번 달부터 바로 선결제 회원이 됩니다. 이번 달 회비 ${Util.formatNumber(s.paidThisMonth)}원을 이미 받았습니다 — 그대로 추가하면 이번 달은 두 번 받게 됩니다.`
            : '이번 달부터 바로 선결제 회원이 됩니다.'));
    }

    goMonth(n) {
        const $w = $(`#${this.id}`);
        const $s = $w.find('#start_ym');
        const $e = $w.find('#end_ym');
        // 'YYYY-MM' 을 n 달 옮긴다. 예전엔 전역 get_next_month/get_prev_month 였다.
        const shift = (ym) => dayjs(ym + '-01').add(n > 0 ? 1 : -1, 'month').format('YYYY-MM');
        $s.val(shift($s.val()));
        $e.val(shift($e.val()));
        this.checkNow();
    }

    save() {
        const self = this;
        const $w = $(`#${this.id}`);
        $.ajax({
            type: 'post',
            url: '/adm/ajax/member/prepay/add',
            data: $w.find('#prepayform').serialize(),
            dataType: 'json',
            success(data) {
                if (data && data.result) {
                    $j.F.Admin.Util.tsalert('success', '장기선결제건이 추가되었습니다.');
                } else {
                    $j.F.Admin.Util.tsalert('error', (data && data.message) || '실패하였습니다.');
                }
                setTimeout(() => self.openLog(), 500);
            },
            error() { $j.F.Admin.Util.tsalert('error', '요청 처리중 오류가 발생했습니다.'); },
        });
    }

    openLog() {
        $j.Ui.JBModal.target('prepay-modal', {
            target: '$j.F.Admin.Member.PrepayLog',
            data: { mbNo: this.mbNo },
            title: '장기선결제 내역',
            width: '800px',
        });
    }

    _esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }
}
